import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Calendar } from "@/components/ui/calendar";
import { Loader2, CalendarX2 } from "lucide-react";
import { it } from "date-fns/locale";

// "YYYY-MM-DD" va interpretato come data locale (new Date(stringa) lo tratterebbe come UTC
// mezzanotte, facendo slittare di un giorno nei fusi orari negativi).
const parseLocalDate = (s) => {
    const [y, m, d] = s.split("-").map(Number);
    return new Date(y, m - 1, d);
};

// Calendario disponibilità in sola lettura: legge il link iCal del channel manager
// (proxy lato backend) e mostra le date occupate come disabilitate/barrate.
export default function AvailabilityCalendar({ propertyId }) {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [busyRanges, setBusyRanges] = useState([]);

    useEffect(() => {
        let active = true;
        setLoading(true);
        setError(false);
        api.get(`/properties/${propertyId}/availability`)
            .then(({ data }) => {
                if (!active) return;
                const ranges = (data.busy || []).map((b) => ({ from: parseLocalDate(b.start), to: parseLocalDate(b.end) }));
                setBusyRanges(ranges);
            })
            .catch(() => { if (active) setError(true); })
            .finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [propertyId]);

    if (loading) {
        return (
            <div data-testid="availability-calendar-loading" className="flex items-center gap-2 text-ink-400 text-sm py-6">
                <Loader2 size={16} className="animate-spin" /> Caricamento calendario disponibilità...
            </div>
        );
    }
    if (error) {
        return (
            <div data-testid="availability-calendar-error" className="flex items-center gap-2 text-ink-400 text-sm py-4">
                <CalendarX2 size={16} /> Calendario disponibilità al momento non disponibile.
            </div>
        );
    }
    const today = new Date();
    const nextBusy = busyRanges.map((r) => r.from).filter((d) => d >= today).sort((a, b) => a - b)[0];
    return (
        <div data-testid="availability-calendar" className="border border-white/10 bg-ink-900/50 p-2 inline-block">
            <Calendar
                locale={it}
                defaultMonth={nextBusy || today}
                disabled={busyRanges}
                modifiersClassNames={{ disabled: "line-through text-red-400/70 opacity-100" }}
                className="text-ink-50"
            />
            <p className="text-[11px] text-ink-400 mt-2">Le date barrate risultano occupate.</p>
        </div>
    );
}
